import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=88b052cc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=88b052cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b052cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88b052cc')) {
      api.createRecord('88b052cc', component.options)
    } else {
      api.reload('88b052cc', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=88b052cc&scoped=true", function () {
      api.rerender('88b052cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/instantDiscount/edit.vue"
export default component.exports